import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { SectionFormComponent } from './section-form.component';


/**
 * ページパターン設定画面 モジュール設定クラス
 *
 * @export SectionFormComponent
 * @class SectionFormComponent
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
  ],
  declarations: [
    SectionFormComponent,
  ],
  providers: [
  ],
  exports: [
    SectionFormComponent,
  ]
})
export class SectionFormModule {
}
